import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import NavLinkAdapter from '@main/core/NavLinkAdapter';
import WdSvgIcon from '@main/core/WdSvgIcon';
import { priorityEnum } from './enums';

export const NotificationCard = (props) => {
  const { item, className } = props;

  const handleClose = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    if (props.onClose) {
      props.onClose(item?.id);
    }
  };

  const handleRedirect = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (props.onClick) {
      props.onClick(item);
    }
  };

  return (
    <Card
      className={clsx(
        'flex items-center relative w-full rounded-16 p-20 min-h-64 shadow space-x-8',
        className
      )}
      // sx={{ backgroundColor: (_theme) => _theme.palette.background.paper, color: (_theme) => _theme.palette.text.primary. }}
      sx={item.priority && priorityEnum[item.priority].variant}
      elevation={0}
      component={item.useRouter ? NavLinkAdapter : 'div'}
      onClick={handleRedirect}
      role="button"
    >
      {item.priority && !item.image && (
        <Box
          sx={{ backgroundColor: 'background.default' }}
          className="flex shrink-0 items-center justify-center w-40 h-40 mr-12 rounded-full"
        >
          <WdSvgIcon className="opacity-75" color={priorityEnum[item.priority].color}>
            {priorityEnum[item.priority].icon}
          </WdSvgIcon>
        </Box>
      )}

      {item.image && (
        <img
          className="shrink-0 w-32 h-32 mr-12 rounded overflow-hidden object-cover object-center"
          src={item.image}
          alt="Notification"
        />
      )}

      <div className="flex flex-col flex-auto">
        {item.title && <Typography className="font-semibold line-clamp-1">{item.title}</Typography>}

        {item.description && (
          <div className="line-clamp-2" dangerouslySetInnerHTML={{ __html: item.description }} />
        )}

        {item.item && (
          <Typography className="mt-8 text-sm leading-none " color="text.secondary">
            {formatDistanceToNow(new Date(item.created_at), { addSuffix: true })}
          </Typography>
        )}
      </div>

      <IconButton
        disableRipple
        className="top-0 right-0 absolute p-8"
        color="inherit"
        size="small"
        onClick={handleClose}
      >
        <WdSvgIcon size={12} className="opacity-75" color="inherit">
          heroicons-solid:x
        </WdSvgIcon>
      </IconButton>
      {item.children}
    </Card>
  );
}
